import { render, staticRenderFns } from "./sectionRigtLeft.vue?vue&type=template&id=5b13b1fa&scoped=true&"
import script from "./sectionRigtLeft.vue?vue&type=script&lang=js&"
export * from "./sectionRigtLeft.vue?vue&type=script&lang=js&"
import style0 from "./sectionRigtLeft.vue?vue&type=style&index=0&id=5b13b1fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b13b1fa",
  null
  
)

export default component.exports